import { render, staticRenderFns } from "./setting-testdoc-ap.vue?vue&type=template&id=0aa2b422"
import script from "./setting-testdoc-ap.vue?vue&type=script&lang=js"
export * from "./setting-testdoc-ap.vue?vue&type=script&lang=js"
import style0 from "./setting-testdoc-ap.vue?vue&type=style&index=0&id=0aa2b422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports